// components/RenewalReminder.js — on the 1st of each month, reminds staff to send renewals.  [marker: renewals-tracker v1]
// Shows once per sign-in session until someone clicks "Renewals are sent for <month>".
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

const SEEN_KEY = 'njjba-renewal-reminder-seen';

export default function RenewalReminder() {
  const [info, setInfo] = useState(null);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let seen = false;
    try { seen = sessionStorage.getItem(SEEN_KEY) === '1'; } catch (_) { /* ignore */ }
    if (seen) return undefined;
    const t = setTimeout(() => {
      api.get('/renewals/reminder').then(r => {
        if (r.data && r.data.show) setInfo(r.data);
        try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (_) { /* ignore */ }
      }).catch(() => {});
    }, 2500);
    return () => clearTimeout(t);
  }, []);

  if (!info) return null;
  const close = () => setInfo(null);

  const markDone = async () => {
    setSaving(true);
    try {
      await api.post('/renewals/reminder/done');
      toast.success(`Marked done for ${info.month}. The reminder will be back on the 1st of next month.`);
      close();
    } catch (_) {
      toast.error('Could not save. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={close} style={{ zIndex: 998 }}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 520 }}>
        <div className="modal-header">
          <span className="modal-title">Membership renewals for {info.month}</span>
          <button className="btn btn-ghost btn-icon" onClick={close} aria-label="Close">✕</button>
        </div>
        <div className="modal-body">
          <p style={{ marginTop: 0 }}>
            It's the start of the month. <strong>{info.count} {info.count === 1 ? 'member has' : 'members have'} not renewed yet</strong> (renewal
            due this month or earlier, and not lapsed).
          </p>
          <p style={{ marginBottom: 0, color: 'var(--gray-600)', fontSize: '0.9rem' }}>
            Send them a renewal batch, or a reminder from an earlier batch. Members lapse automatically 4 months after their renewal date.
          </p>
        </div>
        <div className="modal-footer" style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
          <button className="btn btn-secondary" onClick={close}>Remind me later</button>
          <button className="btn btn-secondary" onClick={markDone} disabled={saving}>
            {saving ? 'Saving…' : `Renewals are sent for ${info.month.split(' ')[0]}`}
          </button>
          <button className="btn btn-primary" onClick={() => { close(); navigate('/renewals'); }}>See who hasn't renewed</button>
        </div>
      </div>
    </div>
  );
}
